// extracted by mini-css-extract-plugin
module.exports = {"CardSystemLinks":"CardSystemLinks_CardSystemLinks__3S59w","CardSystemLinks__title":"CardSystemLinks_CardSystemLinks__title__1SOSW"};